module.exports = __webpack_public_path__ + "static/media/login.631030cb.jpg";